import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/admin/Header';
import Footer from '../components/user/Footer';

function AdminLayout({ children }) {
  const location = useLocation();
  const isFullWidth =
    location.pathname === '/admin/dashboard' ||
    location.pathname === '/admin/organization-docs' ||
    location.pathname === '/admin/roles-and-access' ||
    location.pathname === '/admin/approvalRequest' ||
    location.pathname === '/admin/approval-requests';

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />

      <main className="flex-1 w-full px-4 py-5 sm:px-6 lg:px-8 lg:py-6">
        <div className="mx-auto w-full" style={{ maxWidth: 'var(--layout-max-width, 80rem)' }}>
          <div
            className={
              isFullWidth
                ? ''
                : 'bg-white rounded-2xl shadow-sm border border-gray-100/80 p-5 sm:p-6 lg:p-8 min-h-[400px]'
            }
          >
            {children || <Outlet />}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default AdminLayout;
